import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ExecutionQTestDeviations } from 'src/app/model/execution';
import { UserService } from '../../../../services/user.service';
import { User } from '../../../../model/user';
import { SnackBarService } from '../../../../services/snackBar.service';
import { ExecutionEditQDeviationComponent } from '../execution-edit-q-deviation/execution-edit-q-deviation.component';
import { Subject, takeUntil } from 'rxjs';
import * as _ from 'lodash';
import { MatPaginator, PageEvent } from '@angular/material/paginator';

import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ExecutionQTestDeviationData, TestTypeDeviations } from '../../../../model/execution';
import { TranslateService } from '@ngx-translate/core';

export interface DialogDataDeviationList {
  deviations: ExecutionQTestDeviations[];
  protocolNumber: string; 
  idStatus: number;
  idExecution: number;
  idExecutionTest: number;
  create: boolean;
  deviationSelected: ExecutionQTestDeviations[];
  deviationsComplete: ExecutionQTestDeviations[];
  executionNumber: string;
}
@Component({
    selector: 'app-execution-edit-q-deviation-list',
    templateUrl: './execution-edit-q-deviation-list.component.html',
    styleUrls: ['./execution-edit-q-deviation-list.component.scss'],
    standalone: false,
})
export class ExecutionEditQDeviationListComponent implements OnInit {

  @ViewChild('deviations', { static: true }) deviations: MatTable<any>;
  
  deviation: ExecutionQTestDeviations;
  displayedColumns = ['code','status','modDate','modUser', 'edit'];
  private destroy$ = new Subject<void>();
  currentUser: User;
  totalItems: number;
  dataSource : MatTableDataSource<ExecutionQTestDeviations>;
 
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private dialogRef: MatDialogRef<ExecutionEditQDeviationListComponent>,
    private userService: UserService,
    private snackBarService: SnackBarService,
    private translateService: TranslateService,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataDeviationList) { }

    ngOnInit(): void {
      this.currentUser = this.userService.currentProfile;
      this.dataSource = new MatTableDataSource();

      this.data.deviations = this.data.deviations?.filter((item, index, self) =>
        index === self.findIndex((t) => t.id === item.id)
      );
    }
  
    ngAfterViewInit(): void {
      this.loadPageData();
    }
  
    loadPageData(): void {
      const start = this.paginator.pageIndex * this.paginator.pageSize;
      const end = start + this.paginator.pageSize;

      this.dataSource.data = this.data.deviations.slice(start, end);
    }
  
    onPageChange(event: PageEvent): void {
      const start = event.pageIndex * event.pageSize;
      const end = start + event.pageSize;
  
      this.dataSource.data = this.data.deviations.slice(start, end);
    }



//MOSTRARIA LA DESVIACION SELECCIONADA
  showDeviationSelected(uuid: string) {
		const resSelected = this.data.deviations.find(ee => ee.uuid === uuid);
    const indexRes = this.data.deviations.findIndex(ee => ee.uuid === uuid)

		if (resSelected) {
			const dialogRef = this.dialog.open(ExecutionEditQDeviationComponent, {
				minWidth: '70%',
				maxHeight: '95vh',
				data: {
					deviation: _.cloneDeep(resSelected),
          isEditList: true,
          protocolNumber: this.data.protocolNumber,
          idStatus: this.data.idStatus,
          idExecution: this.data.idExecution,
          idExecutionTest: this.data.idExecutionTest
				}
			});
	
			dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: ExecutionQTestDeviations) => {
				if (result) {
					this.data.deviations[indexRes] = {...result};
          this.deviations.renderRows();
          this.cdr.detectChanges();
				}
			});
		}
	}

  showStatusDeviation(dev: ExecutionQTestDeviations): string {
    const resResolution = dev?.executionQTestDeviationData.find(e => e.idType === TestTypeDeviations.DEVIATION_RESOLUTION);

    if (resResolution) {
      if (resResolution.resolved) {
        return this.translateService.instant('executionEditQ.deviation.closed.label');
      } else {
        return this.translateService.instant('executionEditQ.deviation.open.label');
      }
    } else {
      return this.translateService.instant('executionEditQ.deviation.open.label');
    }
  }

  onOkClick(){
    this.dialogRef.close(this.data.deviations);
  }
  onNoClick() {
    this.dialogRef.close(null);
  }

  createNewDev() {
    const dialogRef = this.dialog.open(ExecutionEditQDeviationComponent, {
      minWidth: '70%',
      maxHeight: '95vh',
      data: {
        protocolNumber: this.data.protocolNumber,
        executionNumber: this.data.executionNumber,
        deviation: new ExecutionQTestDeviations(),
        idStatus: this.data.idStatus,
        idExecution: this.data.idExecution,
        idExecutionTest: this.data.idExecutionTest,
        isEditList: false,
        deviationsComplete: this.data.deviationsComplete
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: ExecutionQTestDeviations) => {
      if (result) {
        if (!this.data.deviations) {
          this.data.deviations = [];
        }
        if (!this.data.deviationsComplete) {
          this.data.deviationsComplete = [];
        }
        this.data.deviations.push(result);
        this.data.deviationsComplete.push(result);
        this.deviations.renderRows();
      }
    });
  }

}
